<form [formGroup]="form" class="company-form">
  <div class="company-form__row">
    <aprova-input
      label="CNPJ"
      [control]="form.controls.cnpj"
      [errorMessages]="errorMessages"
      mask="AA.AAA.AAA/AAAA-00"
      (onBlur)="onCnpjBlur()"
    />
    <aprova-input
      label="Telefone ou celular"
      [control]="form.controls.telefone"
      [errorMessages]="errorMessages"
      mask="(00) 0000-0000||(00) 00000-0000"
    />
  </div>

  <div class="company-form__row">
    <aprova-input
      label="Razão Social"
      [control]="form.controls.razaoSocial"
      [errorMessages]="errorMessages"
    />
    <aprova-input
      label="Nome Fantasia"
      [control]="form.controls.nomeFantasia"
      [errorMessages]="errorMessages"
    />
  </div>

  <div class="company-form__row">
    <aprova-input
      label="E-mail"
      inputType="email"
      [control]="form.controls.email"
      [errorMessages]="errorMessages"
    />
    <aprova-input
      label="Confirmar e-mail"
      inputType="email"
      [control]="form.controls.emailConfirmacao"
      [errorMessages]="errorMessages"
      blockPaste
    />
  </div>

  @if (form.errors?.['emailMismatch'] && form.controls.emailConfirmacao.touched) {
    <p class="company-form__error">Os e-mails não coincidem</p>
  }
</form>

<aprova-validation-error-modal
  [isOpen]="!!validationError()"
  [errorData]="validationError()!"
  (onClose)="closeValidationError()"
  (onRetry)="closeValidationError()"
/>
